export default __webpack_public_path__ + "static/media/loading.2a6fa6b5.gif";